import { coinbaseWallet, walletConnect } from '@wagmi/connectors'
import { createConfig, createConnector, http, injected } from '@wagmi/core'

import { CHAIN_CONFIGS, EChainType } from '@/constants/chains'
import {
  APP_NAME,
  WALLET_BITGET,
  WALLET_COINBASE,
  WALLET_CONNECT,
  WALLET_CONNECT_PROJECT_ID,
  WALLET_ICONS,
  WALLET_METAMASK,
  WALLET_OKX,
  WALLET_PHANTOM,
  WALLET_RABBY,
  WALLET_TRUST,
} from '@/utils'

import { createClient, type Chain } from 'viem'
import { Connector } from 'wagmi'

// from wagmi: connector.id: to whitelist logo, priority
export const WAGMI_CONNECTOR_ID = {
  WALLET_CONNECT_CONNECTOR_ID: 'walletConnect',
  INJECTED_CONNECTOR_ID: 'injected',
  COINBASE_SDK_CONNECTOR_ID: 'coinbaseWalletSDK',
  COINBASE_RDNS: 'com.coinbase.wallet',
  METAMASK_RDNS: 'io.metamask',
  BITGET: 'com.bitget.web3',
  RABBY: 'io.rabby',
  OKX: 'com.okex.wallet',
  TRUST: 'com.trustwallet.app',
  PHANTOM: 'app.phantom',
}

// wagmi id to our id
export const MAPPING_WAGMI_ID: Record<string, string> = {
  [WAGMI_CONNECTOR_ID.WALLET_CONNECT_CONNECTOR_ID]: WALLET_CONNECT,
  [WAGMI_CONNECTOR_ID.COINBASE_SDK_CONNECTOR_ID]: WALLET_COINBASE,
  [WAGMI_CONNECTOR_ID.COINBASE_RDNS]: WALLET_COINBASE,
  [WAGMI_CONNECTOR_ID.METAMASK_RDNS]: WALLET_METAMASK,
  [WAGMI_CONNECTOR_ID.RABBY]: WALLET_RABBY,
  [WAGMI_CONNECTOR_ID.BITGET]: WALLET_BITGET,
  [WAGMI_CONNECTOR_ID.OKX]: WALLET_OKX,
  [WAGMI_CONNECTOR_ID.TRUST]: WALLET_TRUST,
  [WAGMI_CONNECTOR_ID.PHANTOM]: WALLET_PHANTOM,
}

export const getWagmiWalletIcon = (e: Connector) => {
  return WALLET_ICONS[MAPPING_WAGMI_ID[e.id]] || e.icon || ''
}

const WC_PARAMS = {
  showQrModal: true,
  projectId: WALLET_CONNECT_PROJECT_ID,
  metadata: {
    name: APP_NAME,
    description: APP_NAME,
    url: window.location.href,
    icons: [`${window.location.origin}/icons/favicon.ico`],
  },
  qrModalOptions: {
    chainImages: undefined,
    themeMode: 'dark' as const,
  },
}
function injectedWithFallback() {
  return createConnector((config) => {
    const injectedConnector = injected()(config)

    return {
      ...injectedConnector,
      connect(...params) {
        if (!window.ethereum) {
          window.open('https://metamask.io/', 'inst_metamask')
        }
        return injectedConnector.connect(...params)
      },
      get name() {
        return !window.ethereum || window.ethereum?.isMetaMask ? 'MetaMask' : 'Browser Wallet'
      },
    }
  })
}

const chains = Object.values(CHAIN_CONFIGS)
  .filter((e) => e.wagmiChain && e.type === EChainType.EVM)
  .map((e) => e.wagmiChain) as [Chain, ...Chain[]]

export const wagmiConfig = createConfig({
  chains,
  connectors: [
    injectedWithFallback(),
    walletConnect(WC_PARAMS),
    coinbaseWallet({
      appName: APP_NAME,
      appLogoUrl: `${window.location.origin}/icons/favicon.ico`,
      reloadOnDisconnect: false,
      enableMobileWalletLink: true,
    }),
  ],
  client({ chain }) {
    return createClient({
      chain,
      batch: { multicall: true },
      pollingInterval: 12_000,
      transport: http(),
    })
  },
})
